import countryCodes from './countries.json';

/** Build country-name to 2-letter country code map */
export const getCountryCodeMap = (): Map<string, string> => {
  const countryCodeMap = new Map<string, string>();

  Object.keys(countryCodes).forEach((countyName) => {
    const countyCode = countryCodes[countyName];
    countryCodeMap.set(countyName.toLowerCase(), countyCode.toLowerCase());
  });

  return countryCodeMap;
};
